const actions = {
    initClientApp: (draft, {clientAppId, clientApp, reload}) => {
        draft.clientAppId = clientAppId;
        draft.clientApp = clientApp;
        draft.reload = reload;
    },

    setBindAppApi: (draft, value) => {
        draft.hasBindAppApi = value || true;
    },
};

export default actions;
